import React from "react";
import PolicesResourcesListPageContainer from "./PolicesResourcesListPageContainer";

export class PolicesResourcesListPage extends React.Component {
  render() {
    return <PolicesResourcesListPageContainer {...this.props} />;
  }
}
